import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Buttons, Text, Inputs } from '@taxdown/piccolo-web';
import EventService from 'Services/events';
import { setUserInfoAction } from 'Store/modules/auth/actions';
import { phoneSelector } from 'Store/modules/auth/selectors';
import { setIsLoadingAction, setIsNotLoadingAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import ContentContainer from 'Components/UI/ContentContainer';
import FormContainer from 'Components/UI/FormContainer';
import TwoColLayout from 'Components/Layouts/TwoColLayout';
import ContentBottom from 'Components/UI/ContentBottom';
import { routes } from 'Constants/routes';
import { useFetchSaveUserphone } from './hooks';

const RequestPhoneXml = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [phone, setPhone] = useState<string>();
  const [isValid, setIsValid] = useState(false);
  const { mutate, isLoading } = useFetchSaveUserphone({
    route: routes.DATAGATHERING_REFERRAL_XML,
    onHideModal: () => dispatch(setIsNotLoadingAction()),
  });
  const phoneSaved = useSelector(phoneSelector);

  const handleSubmit = (): void => {
    if (phone) {
      EventService.formSubmitted({
        screenId: 'RequestPhone',
        values: phone,
      });
      mutate(phone);
      dispatch(setUserInfoAction({ user: { phone } }));
    }
  };

  useEffect(() => {
    if (isLoading) {
      dispatch(setIsLoadingAction());
    }
  }, [isLoading]);

  useEffect(() => {
    if (phoneSaved) {
      setPhone(phoneSaved);
      setIsValid(true);
    }
  }, []);

  return (
    <TwoColLayout>
      <ContentContainer>
        <FormContainer>
          <Text type="fds_heading_bold_H4" color="dark_500" mb="fds_size_24">
            {t('validations:RequestPhone.header')}
          </Text>
          <Text type="fds_paragraph_regular_M" color="dark_500" mb="fds_size_32">
            {t('validations:RequestPhone.text')}
          </Text>
          <Inputs.Phone
            value={phone}
            label={t('validations:PhoneInput.label')}
            placeholder="(1) 483 1212891"
            defaultCountry="MX"
            onChange={(value, error) => {
              setPhone(value);
              setIsValid(!error);
            }}
            id="phoneInput"
            hasError={Boolean(phone && !isValid)}
            errorMsg={t('account:UpdatePhone.Input.error')}
          />
        </FormContainer>
        <ContentBottom>
          <Buttons.Classic
            size="m"
            mode="success"
            disabled={!isValid}
            testID="dgContinueButton"
            onClick={handleSubmit}
            label={t('Button.continue')}
          />
        </ContentBottom>
      </ContentContainer>
    </TwoColLayout>
  );
};

export default RequestPhoneXml;
